/** Visual tokens aligned with avipair_leaderboard_soft_ui.html */

export const lb = {
  text: "#344767",
  muted: "#7b809a",
  white: "#ffffff",
  gradientDark: "linear-gradient(195deg, #42424a 0%, #191919 100%)",
  gradientBlue: "linear-gradient(195deg, #49a3f1 0%, #1a73e8 100%)",
  gradientGreen: "linear-gradient(195deg, #66BB6A 0%, #43A047 100%)",
  gradientOrange: "linear-gradient(195deg, #FFA726 0%, #FB8C00 100%)",
  shadowCard:
    "0 2px 12px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.05)",
  shadowHeader: "0 4px 20px rgba(0,0,0,0.14), 0 7px 10px rgba(0,0,0,0.12)",
  shadowTableHeader: "0 4px 20px rgba(26,115,232,0.35)",
  radiusLg: "1rem",
  radiusMd: "10px",
  radiusSm: "8px",
  monoFont: '"Roboto Mono", "SF Mono", ui-monospace, monospace',
};

export function statIconGradient(variant) {
  switch (variant) {
    case "success":
      return lb.gradientGreen;
    case "warning":
      return lb.gradientOrange;
    case "dark":
      return lb.gradientDark;
    default:
      return lb.gradientBlue;
  }
}

export function kpiIconGradient(key) {
  switch (key) {
    case "green":
      return lb.gradientGreen;
    case "orange":
      return lb.gradientOrange;
    default:
      return lb.gradientBlue;
  }
}
